import { useMemo } from 'react'

import { CurrenciesFilterDataDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { createCurrencyFilter, dateFilter, statusFilter } from './filters'

export const usePaymentsFilters = () => {
  const { data: currenciesData } = useQuery(CurrenciesFilterDataDocument)

  const currencyOptions = useMemo(() => {
    const currencies = currenciesData?.apiCore?.currencies || []
    return currencies.map((currency) => ({
      label: `${currency.isoCode} - ${currency.name}`,
      value: currency.isoCode,
    }))
  }, [currenciesData])

  // Note: dueDate is now a navigationFilter (visible DateNavigator) instead of a regular filter
  return useMemo(
    () => ({
      status: statusFilter(),
      date: dateFilter(),
      currency: createCurrencyFilter(currencyOptions),
    }),
    [currencyOptions]
  )
}
